// Import the functions you need from the SDKs you need
import { initializeApp } from 'firebase/app';
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: 'AIzaSyC4Vy_DfuRHTzyFdpntNTV8besnR4cVyCM',
  authDomain: 'souvenirs-722b0.firebaseapp.com',
  projectId: 'souvenirs-722b0',
  storageBucket: 'souvenirs-722b0.appspot.com',
  messagingSenderId: '689185944879',
  appId: '1:689185944879:web:3b080836509b86696cddda',
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export default app;
